import {
  any,
  concat,
  includes,
  isEmpty,
  isNil,
  pipe,
  values,
  without,
} from "ramda";

export const anyValue = pipe(
  // @ts-expect-error TODO please fix this error
  values,
  any((value) => !(isEmpty(value) || isNil(value)))
);

export function toggleArrayItem<T>(item: T, array: T[]): T[] {
  if (includes(item, array)) {
    return without([item], array);
  } else {
    return concat<T>(array, [item]);
  }
}
